//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React, { CSSProperties } from 'react';
import styled from 'styled-components';

import LabeledCheckbox from '@components/atoms/labeled-checkbox/LabeledCheckbox';
import Text from '@components/atoms/text/Text';
import { ILabel } from '@models/ILabel';
import { Mixins } from '@theme/mixins';

interface Props {
  label: ILabel;
  isInlineCount?: boolean;
  isChecked: boolean;
  handleCheckboxClick: (isChecked: boolean) => void;
  className?: string;
  style?: CSSProperties;
}

const LabelsSelectCheckboxRow = ({
  className,
  handleCheckboxClick,
  isChecked,
  isInlineCount = false,
  label,
  style,
}: Props) => {
  const { count, label: title } = label;

  const handleClick = () => handleCheckboxClick(!isChecked);

  const displayCount = isInlineCount ? ` (${count})` : count;

  return (
    <CheckboxRow
      className={className}
      isInlineCount={isInlineCount}
      style={style}
    >
      <LabeledCheckbox
        handleClick={handleClick}
        isChecked={isChecked}
        label={title}
      />
      <StyledText mixin={Mixins.Text.Body} onClick={handleClick}>
        {displayCount}
      </StyledText>
    </CheckboxRow>
  );
};

export default LabelsSelectCheckboxRow;

const StyledText = styled(Text)(
  ({ theme }) => `
  padding: ${theme.spacings[1]};
`,
);

const CheckboxRow = styled.div<{ isInlineCount: boolean }>(
  ({ isInlineCount }) => `
  display: flex;
  align-items: center;
  justify-content: ${isInlineCount ? 'unset' : 'space-between'};
`,
);
